var React = require('react');

var Loading = require('./Loading');
var Header = require('./Header');

var style = {
	appRoot: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%'
	}
};

var App = React.createClass({

	propTypes: {
		signOut: React.PropTypes.func.isRequired
	},

	contextTypes: {
		router: React.PropTypes.object.isRequired
	},

	componentWillReceiveProps: function(nextProps) {
		const { router } = this.context;
		const { auth }	 = this.props;

		var nextPropsAuth   = nextProps.auth.authenticated,
			denied 	   = auth.authenticated && !nextPropsAuth,
			authorized = !auth.authenticated && nextPropsAuth;

		if (denied) {
			return router.replace('/');
		} else if (authorized) {
			return router.location.state ? router.replace(router.location.state.nextPathname) : router.replace('/');
		}
	},

	refresh() {
		return this.props.refresh();
	},

	signOut() {
		return this.props.signOut();
	},

	getTypeHeader: function() {
		return this.props.location.pathname.indexOf('admin') > -1;
	},

	getActiveURL: function() {
		return this.props.location.query.filter || 'order';
	},

	render: function() {
		var me = this, loading = me.props.loading;

		return (
			<div style={style.appRoot}>
				<Loading loading={loading} />

				<Header
					active={me.getActiveURL()}
					refresh={me.refresh}
					authenticated={me.props.auth.authenticated}
					typeHeader={me.getTypeHeader() ? 'admin' : 'client'}
					admin={me.props.auth.isAdmin}
					signOut={me.signOut}
				/>

				{me.props.children}

				{me.getTypeHeader() === true ? (<footer className="app-footer">
					{"AVA Mobile"}
				</footer>) : null}
			</div>
		);
	}
});

module.exports = App;


// WEBPACK FOOTER //
// ./src/components/App.jsx